import { FailureActionPayload } from 'store/errors/types';
import { GetLookupDataPayload, GetLookupDataSuccess } from './types';
import { createAsyncAction } from 'typesafe-actions';

export const getLookupData = createAsyncAction('GET_LOOKUP_DATA', 'GET_LOOKUP_DATA_SUCCESS', 'GET_LOOKUP_DATA_FAILURE')<
  GetLookupDataPayload,
  GetLookupDataSuccess,
  FailureActionPayload
>();
